import React from "react";
import { Field } from "react-final-form";
 import { TextFieldAdapter }from "@soqs/common";
const AddressComplexName = (props) => {
  let { required, name } = props;

  if (name === undefined) {
    name = "";
  //} else {
  //  name = "_" + name;
  }

  if (required === undefined) {
    required = false;
  }
  const isValid = (tel) => {
    const re = /^[ "&-.0-:A-Za-z]{1,28}$/;
    return (tel || !required) &&
      (re.test(tel) || (!required && (tel === undefined || tel?.length === 0)))
      ? undefined
      : "Enter a valid complex name";
  };

  return (
    <Field
      name={name}
      validate={isValid}
      label="Complex Name"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: 28 }}
    />
  );
};

export default AddressComplexName;
